import { defineMessages } from 'react-intl';

export default defineMessages({
  regularApplicationWeekly: {
    id: 'app.components.Availability.regularApplicationWeekly',
    defaultMessage:
      'every {nthWeek, selectordinal, one {} two {2nd} few {3rd} other {#th}} week',
  },
  regularApplicationMonthly: {
    id: 'app.components.Availability.regularApplicationMonthly',
    defaultMessage:
      'every {nth, selectordinal, one {1st} two {2nd} few {3rd} other {#th}} {weekday} of the month',
  },
  addAvailability: {
    id: 'app.components.Availability.addAvailability',
    defaultMessage: 'Add availability',
  },
  emptyStateText: {
    id: 'app.components.Availability.emptyStateText',
    defaultMessage:
      'Manage in which time frames you are available for service. If a shift is scheduled at a time where you are available, you will be automatically applied for that shift.',
  },
});
